import { frontendURL } from '../../../helper/URLHelper';
import {
  LAIS_CAPTACAO_PERMISSIONS,
  laisCanonicalRedirect,
} from '../laisRouteHelpers';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/captacao'),
    name: 'lais_captacao_index',
    redirect: laisCanonicalRedirect('lais_prateleira_captacao'),
    meta: { permissions: LAIS_CAPTACAO_PERMISSIONS },
  },
];
